import { Canvas } from "fabric";
import TextObject from "../objects/TextObject";
import { TextColor } from "../tools/TextTool";

class TextUtils {
  static getTextObjectFromCanvas(canvas: Canvas) {
    return canvas.getObjects().find((object) => object instanceof TextObject);
  }

  static updateTextObjectFill(canvas: Canvas, fill: TextColor) {
    const textObject = this.getTextObjectFromCanvas(canvas);

    if (textObject) {
      textObject.set({ fill });
      canvas.renderAll();
    }
  }
}

export default TextUtils;
